export * from './DoubleImageWidget'
